import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
import { faqs } from '../data/pack';
export const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-61" data-mp="1cf05lglr3epm">
      <div className="mb-12 text-center" data-id="element-62" data-mp="1cft6w21xxc0d">
        <h2 className="font-display text-[22px] font-bold uppercase tracking-[0.12em] text-brand-burgundy md:text-4xl" data-id="element-63" data-mp="2a28kgsr8xpin">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="space-y-4" data-id="element-64" data-mp="2512pspe0zs6h">
        {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return <div key={faq.q} className="paper-panel overflow-hidden rounded-2xl" data-id="element-65" data-mp="1v581bdn4f2vs" data-mpi={i}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between px-6 py-5 text-left transition-colors duration-200 ease-out hover:bg-brand-surfaceLight/60" data-id="element-66" data-mp="opyrbcq8l9cf">
                <span className="pr-8 text-[15px] font-semibold text-brand-goldDark md:text-base lg:text-lg" data-id="element-67" data-mp="1pm1rrqjfvojl">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-68" data-mp="1fnud5ecmhikr" />
              </button>
              <AnimatePresence initial={false} data-id="element-69" data-mp="16ps6oja4dxq3">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-70" data-mp="s0w1qv3d10tp">
                    <div className="border-t border-brand-goldDark/15 px-6 pb-5 pt-4 text-[14px] leading-relaxed text-brand-text md:text-base" data-id="element-71" data-mp="2pn58he9kfci3">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
};